/* TRAFE theme JS */
(function(){
  'use strict';

  function $(s, c){ return (c||document).querySelector(s); }
  function $all(s, c){ return Array.prototype.slice.call((c||document).querySelectorAll(s)); }

  window.trafeToast = function(msg){
    var el = $('#toast'); if(!el) return;
    el.textContent = msg; el.classList.add('show');
    clearTimeout(el._t); el._t = setTimeout(function(){ el.classList.remove('show'); }, 2600);
  };

  function money(cents){
    var cur = (window.trafe && window.trafe.moneyFormat) || 'LE {{amount}}';
    var amount = (cents/100).toLocaleString(undefined, {maximumFractionDigits: 2});
    return cur.replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]*>/g,'');
  }

  var header = $('header.site');
  if(header){
    window.addEventListener('scroll', function(){
      header.classList.toggle('scrolled', window.scrollY > 10);
    }, {passive:true});
  }

  var drawer = $('#drawer');
  window.trafeOpenDrawer = function(){ if(drawer) drawer.classList.add('open'); };
  window.trafeCloseDrawer = function(){ if(drawer) drawer.classList.remove('open'); };
  if(drawer){ drawer.addEventListener('click', function(e){ if(e.target === drawer) drawer.classList.remove('open'); }); }

  /* ---------- reveal + counters ---------- */
  var counted = new WeakSet();
  function runCounter(el){
    if(!el.dataset || !el.dataset.count || counted.has(el)) return;
    counted.add(el);
    var target = +el.dataset.count, suffix = el.dataset.suffix || '';
    var dur = 1400, start = performance.now();
    (function tick(now){
      var p = Math.min(1, ((now||performance.now()) - start) / dur);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(target * eased) + suffix;
      if(p < 1) requestAnimationFrame(tick);
    })(start);
  }
  if('IntersectionObserver' in window){
    var obs = new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if(!en.isIntersecting) return;
        en.target.classList.add('in');
        obs.unobserve(en.target);
        $all('[data-count]', en.target).forEach(runCounter);
        if(en.target.hasAttribute('data-count')) runCounter(en.target);
      });
    }, {threshold:.15});
    $all('.reveal, [data-count]').forEach(function(el){ obs.observe(el); });
  } else {
    $all('.reveal').forEach(function(el){ el.classList.add('in'); });
    $all('[data-count]').forEach(runCounter);
  }

  /* ---------- quiz ---------- */
  $all('[data-quiz]').forEach(function(box){
    var scents;
    try { scents = JSON.parse(box.getAttribute('data-quiz')); } catch(e){ return; }
    if(!scents || !scents.length) return;
    var qWrap = $('.quiz-q', box), rWrap = $('.quiz-result', box), bar = $('.quiz-progress i', box);
    var strings = window.trafe && window.trafe.quiz || {};
    var step = 0, pick = 0;
    function render(){
      if(step < 2){
        rWrap.style.display = 'none'; qWrap.style.display = 'block';
        bar.style.width = step === 0 ? '33%' : '66%';
        var q = step === 0 ? strings.q1 : strings.q2;
        var opts = step === 0 ? strings.q1opts : strings.q2opts;
        qWrap.innerHTML = '<h3>' + q + '</h3><div class="quiz-opts">' +
          (opts||[]).map(function(o,i){ return '<button type="button" class="quiz-opt" data-i="'+i+'">'+o+'</button>'; }).join('') + '</div>';
        $all('.quiz-opt', qWrap).forEach(function(b){
          b.addEventListener('click', function(){
            var i = +b.getAttribute('data-i');
            if(step === 0){ pick = i; step = 1; } else { pick = Math.round((pick + i)/2); step = 2; }
            if(pick > scents.length - 1) pick = scents.length - 1;
            render();
          });
        });
      } else {
        bar.style.width = '100%';
        qWrap.style.display = 'none'; rWrap.style.display = 'block';
        var s = scents[pick];
        rWrap.innerHTML =
          '<div class="badge" style="background:linear-gradient(140deg,'+s.color+','+s.color+'bb)">✦</div>' +
          '<p style="letter-spacing:.2em;text-transform:uppercase;font-size:.8rem;color:var(--gold)">'+(strings.pre||'')+'</p>' +
          '<h3>'+s.title+'</h3><p style="max-width:26rem;margin-inline:auto">'+ (s.desc||'') +'</p>' +
          '<div style="display:flex;gap:.8rem;justify-content:center;flex-wrap:wrap">' +
          '<a class="btn btn-primary" href="'+s.url+'">'+(strings.cta||'')+' '+s.title+'</a>' +
          '<button type="button" class="btn btn-ghost" data-again>'+(strings.again||'')+'</button></div>';
        $('[data-again]', rWrap).addEventListener('click', function(){ step = 0; render(); });
      }
    }
    render();
  });

  /* ---------- CART CORE ---------- */
  var cartFly = $('#CartFly');
  var strings = (window.trafe && window.trafe.strings) || {};

  function setCount(n){
    $all('.cart-count').forEach(function(c){ c.textContent = n; });
  }

  function renderCartDrawer(cart){
    if(!cartFly) return;
    var box = $('#CartFlyItems');
    setCount(cart.item_count);
    $('#CartFlySub').textContent = money(cart.items_subtotal_price);
    if(!cart.items.length){
      box.innerHTML = '<div class="cf-empty">' + (strings.cartEmpty||'') +
        '<br><a class="btn btn-ghost" href="' + ((window.trafe.routes&&window.trafe.routes.allProducts)||'/collections/all') + '">' + (strings.continueShopping||'') + '</a></div>';
      return;
    }
    box.innerHTML = cart.items.map(function(it, i){
      var vt = (it.variant_title && it.variant_title !== 'Default Title') ? it.variant_title : '';
      var img = it.image ? it.image.replace(/(\.[a-z]{3,4})(\?|$)/, '_140x$1$2') : '';
      return '<div class="cf-line" data-line="'+(i+1)+'">' +
        '<div class="thumb">' + (img ? '<img src="'+img+'" alt="" loading="lazy">' : '') + '</div>' +
        '<div class="inf"><b>'+ it.product_title +'</b>' +
        (vt ? '<span class="var">'+vt+'</span>' : '') +
        '<div class="lp">'+ money(it.final_line_price) +'</div></div>' +
        '<div class="ops">' +
          '<div class="qty qty-sm">' +
            '<button type="button" data-dqty data-line="'+(i+1)+'" data-d="-1">−</button>' +
            '<b>'+ it.quantity +'</b>' +
            '<button type="button" data-dqty data-line="'+(i+1)+'" data-d="1">+</button>' +
          '</div>' +
          '<span class="cf-rm" data-dremove data-line="'+(i+1)+'">'+ (strings.remove||'✕') +'</span>' +
        '</div></div>';
    }).join('');
  }

  function fetchCart(){ return fetch('/cart.js').then(function(r){ return r.json(); }); }

  function changeLine(line, qty){
    if(cartFly) $('#CartFlyItems').classList.add('cf-loading');
    return fetch('/cart/change.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({line: line, quantity: qty})
    }).then(function(r){ return r.json(); }).then(function(cart){
      renderCartDrawer(cart);
      if(cartFly) $('#CartFlyItems').classList.remove('cf-loading');
      return cart;
    });
  }

  window.trafeCartOpen = function(){
    if(!cartFly) return;
    fetchCart().then(renderCartDrawer);
    cartFly.classList.add('open');
    cartFly.setAttribute('aria-hidden','false');
    document.body.style.overflow = 'hidden';
  };
  window.trafeCartClose = function(){
    if(!cartFly) return;
    cartFly.classList.remove('open');
    cartFly.setAttribute('aria-hidden','true');
    document.body.style.overflow = '';
  };

  if(cartFly){
    $all('.cart-link').forEach(function(a){
      a.addEventListener('click', function(e){ e.preventDefault(); window.trafeCartOpen(); });
    });
    cartFly.addEventListener('click', function(e){
      var qb = e.target.closest('[data-dqty]');
      if(qb){
        var line = +qb.getAttribute('data-line');
        var cur = +qb.parentElement.querySelector('b').textContent;
        var next = Math.max(0, cur + (+qb.getAttribute('data-d')));
        changeLine(line, next);
        return;
      }
      var rb = e.target.closest('[data-dremove]');
      if(rb){ changeLine(+rb.getAttribute('data-line'), 0); }
    });
  }

  if($('#CartPage')){
    $all('[data-cline]').forEach(function(b){
      b.addEventListener('click', function(){
        var line = +b.getAttribute('data-cline');
        var cur = +b.parentElement.querySelector('[data-cqty]').textContent;
        var next = Math.max(0, cur + (+b.getAttribute('data-d')));
        b.disabled = true;
        changeLine(line, next).then(function(){ location.reload(); });
      });
    });
  }

  /* fly-to-cart animation (from any source image) */
  function flyToCart(srcImg){
    var img = srcImg || $('#PdpImg');
    var target = $('.cart-link');
    if(!img || !target) return;
    var r1 = img.getBoundingClientRect(), r2 = target.getBoundingClientRect();
    if(!r1.width || !r2.width) return;
    var size = Math.min(110, Math.max(50, r1.width * .35));
    var ghost = document.createElement('img');
    ghost.src = img.currentSrc || img.src; ghost.className = 'fly-ghost';
    ghost.style.left = (r1.left + r1.width/2 - size/2) + 'px';
    ghost.style.top = (r1.top + r1.height/2 - size/2) + 'px';
    ghost.style.width = size + 'px'; ghost.style.height = size + 'px';
    document.body.appendChild(ghost);
    requestAnimationFrame(function(){
      requestAnimationFrame(function(){
        var dx = (r2.left + r2.width/2) - (r1.left + r1.width/2);
        var dy = (r2.top + r2.height/2) - (r1.top + r1.height/2);
        ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(.12) rotate(10deg)';
        ghost.style.opacity = '.2';
      });
    });
    setTimeout(function(){
      ghost.remove();
      target.classList.add('bump');
      setTimeout(function(){ target.classList.remove('bump'); }, 500);
    }, 760);
  }

  /* quick add from product cards */
  window.trafeCardAdd = function(e, variantId){
    e.preventDefault(); e.stopPropagation();
    var btn = e.currentTarget || e.target.closest('.cta-cart');
    var card = btn ? btn.closest('.scent-card') : null;
    var img = card ? card.querySelector('.imgbox img') : null;
    if(btn) btn.setAttribute('disabled','');
    fetch((window.trafe.routes && window.trafe.routes.cartAdd) || '/cart/add.js', {
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({items:[{id: variantId, quantity: 1}]})
    }).then(function(r){
      if(!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function(){
      flyToCart(img);
      setTimeout(function(){ window.trafeCartOpen(); }, 700);
    }).catch(function(){
      window.trafeToast(strings.cartError || 'Something went wrong');
    }).finally(function(){
      if(btn) btn.removeAttribute('disabled');
    });
    return false;
  };

  /* ---------- product form ---------- */
  var pform = $('[data-product-form]');
  if(pform){
    var productJson = $('#ProductJson');
    var product = productJson ? JSON.parse(productJson.textContent) : null;

    function currentVariant(){
      if(!product) return null;
      var values = [];
      $all('[data-option-group]', pform).forEach(function(group){
        var active = $('.scent-pill.active', group);
        if(active) values.push(active.getAttribute('data-value'));
      });
      if(!values.length) return product.variants[0];
      return product.variants.find(function(v){
        return v.options.every(function(opt, i){ return opt === values[i]; });
      }) || product.variants[0];
    }

    function qty(){ return Math.max(1, parseInt(($('#Qty')||{}).value || '1', 10)); }

    function refresh(){
      var v = currentVariant(); if(!v) return;
      $('#VariantId').value = v.id;
      var priceEl = $('[data-price]');
      if(priceEl) priceEl.innerHTML = money(v.price) + (v.compare_at_price > v.price ? ' <s>'+money(v.compare_at_price)+'</s>' : '');
      if(v.featured_image && $('#PdpImg')){ $('#PdpImg').src = v.featured_image.src; }
      var btns = $all('[data-buy-btn]');
      btns.forEach(function(b){ b.toggleAttribute('disabled', !v.available); });
      var sb = $('#StickyPrice');
      if(sb) sb.textContent = money(v.price * qty());
    }

    $all('[data-option-group]', pform).forEach(function(group){
      $all('.scent-pill', group).forEach(function(pill){
        pill.addEventListener('click', function(){
          $all('.scent-pill', group).forEach(function(p){ p.classList.remove('active'); });
          pill.classList.add('active');
          var tint = pill.getAttribute('data-tint');
          var box = $('#PdpImgBox');
          if(tint && box) box.style.setProperty('--tint', tint);
          refresh();
        });
      });
    });

    $all('[data-qty-change]').forEach(function(b){
      b.addEventListener('click', function(){
        var input = $('#Qty');
        input.value = Math.max(1, Math.min(9, qty() + (+b.getAttribute('data-qty-change'))));
        refresh();
      });
    });

    window.trafeAddToCart = function(goCheckout){
      var v = currentVariant(); if(!v) return Promise.resolve();
      var buyBtns = $all('[data-buy-btn]');
      buyBtns.forEach(function(b){ b.setAttribute('disabled',''); });
      return fetch((window.trafe.routes && window.trafe.routes.cartAdd) || '/cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({items:[{id: v.id, quantity: qty()}]})
      }).then(function(r){
        if(!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function(){
        if(goCheckout){ window.location.href = '/checkout'; }
        else {
          flyToCart();
          setTimeout(function(){ window.trafeCartOpen(); }, 700);
        }
      }).catch(function(){
        window.trafeToast(window.trafe.strings.cartError || 'Something went wrong');
      }).finally(function(){
        buyBtns.forEach(function(b){ b.removeAttribute('disabled'); });
        refresh();
      });
    };

    refresh();
  }

  /* ---------- quick order modal ---------- */
  var modal = $('#QuickOrderModal');
  window.trafeOpenOrder = function(){
    if(!modal) return;
    if(pform){
      var title = $('[data-product-title]');
      var img = $('#PdpImg');
      var priceEl = $('[data-price]');
      if(title && $('#OmProd')) $('#OmProd').textContent = title.textContent;
      if(img && $('#OmThumb')) $('#OmThumb').src = img.src;
      if(priceEl && $('#OmPrice')) $('#OmPrice').textContent = priceEl.textContent;
    }
    modal.classList.add('open');
    document.body.style.overflow = 'hidden';
  };
  window.trafeCloseOrder = function(){
    if(!modal) return;
    modal.classList.remove('open');
    document.body.style.overflow = '';
  };
  if(modal){
    modal.addEventListener('click', function(e){ if(e.target === modal) window.trafeCloseOrder(); });
    var go = $('#QuickOrderCheckout');
    if(go){
      go.addEventListener('click', function(){
        if(window.trafeAddToCart){ window.trafeAddToCart(true); }
        else { window.location.href = '/checkout'; }
      });
    }
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape'){ window.trafeCloseOrder && window.trafeCloseOrder(); window.trafeCartClose && window.trafeCartClose(); }
  });

  $all('[data-thumb]').forEach(function(b){
    b.addEventListener('click', function(){
      $all('.pdp-thumbs button').forEach(function(x){ x.classList.remove('active'); });
      b.classList.add('active');
      var main = $('#PdpImg');
      if(main) main.src = b.getAttribute('data-thumb');
    });
  });
})();
